import Loader from "../../Tools/Loader";
import { useEffect } from "react";

export default function Index(){

    useEffect(() => {

        window.location.href = "/redirect/marketing";

    }, [])

    return <Loader />
}